import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import Item from './Item';
import { formName } from 'data/formNames';
import { bindActionCreators } from 'redux';

const LiftAndCranesList = ({ liftsCranes = {} }) => {
    const items = React.useMemo(
        () => Object.values(liftsCranes),
        [liftsCranes],
    );

    return (
        <React.Fragment>
            <div className='main__title'>
                Available Lift and Cranes
            </div>

            <div className='lift-and-cranes'>
                {items.map((liftCrane, index) => (
                    <Item
                        key={`${liftCrane.id || index}`}
                        liftCrane={liftCrane}
                        liftsCranes={liftsCranes}
                    />
                ))}
            </div>
        </React.Fragment>
    );
};

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state, { parentProps }) => ({
        forms: state.form,
        formName: parentProps.form,
        liftsCranes: selector(state, 'liftsCranes'),
    }),
    dispatch => bindActionCreators({

    }, dispatch),
)(LiftAndCranesList);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/LiftAndCranes/List.jsx